import { render, staticRenderFns } from "./CtaHero.vue?vue&type=template&id=72842d3c&"
import script from "./CtaHero.vue?vue&type=script&lang=js&"
export * from "./CtaHero.vue?vue&type=script&lang=js&"
import style0 from "./CtaHero.vue?vue&type=style&index=0&id=72842d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports